<template>
	<div
		ref="facettedListRef"
		class="facetted-list grid"
		:class="filterGroups.length <= 0 ? 'facetted-list--no-filters' : ''"
	>
		<ListHeadline v-if="hasHeader">
			{{ dataProps.listHeadline }}
		</ListHeadline>
		<Spinner v-show="loading" />
		<div
			v-if="
				dataProps.showYearFilter != 'False' ||
				dataProps.listType == 'NewsList'
			"
			class="col-12"
			:class="filterGroups.length <= 0 ? 'padding-bottom-0' : ''"
		>
			<NewslistFilters
				:filters="years"
				:chosenFilters="
					activeFilters.yearFilters &&
					activeFilters.yearFilters.length > 0 != ''
						? activeFilters.yearFilters
						: []
				"
				@update="onYearFilterUpdate"
				:ariaLabelFilterOnYears="dataProps.arialabelfilteronyears"
			></NewslistFilters>
		</div>
		<ListFilters
			v-if="!filtersUpdate && filterGroups.length > 0"
			:chosenFilters="activeFilters"
			:show-date-filters="showDateFilters"
			:show-text-filter="showTextFilter"
			:show-year-filter="dataProps.showYearFilter == 'True'"
			:header-type="hasHeader ? 'h3' : 'h2'"
			@update="onFilterUpdate"
			@submit="onSubmit"
			:filterBy="dataProps.filterBy"
			@updateFromDate="onUpdateFromDate"
			@updateSearchTerm="onUpdateSearchTerm"
			@updateToDate="onUpdateToDate"
			@updateTagFilter="onUpdateTagFilter"
			:buttonText="buttonText"
			:searchPlaceholder="dataProps.searchPlaceholder"
			:fromDateDefault="fromDateDefault"
			:searchTermDefault="searchTermDefault"
			:toDateDefault="toDateDefault"
			:searchLabel="dataProps.searchLabel"
			:defaultTagIds="defaultTagIds"
			:value="{ fromDate: null, toDate: null }"
			:filterGroups="filterGroups"
			:invalidMessage="dataProps.invalidmessage"
		>
		</ListFilters>
		<div
			:class="'col-12_sm-12_md-' + (filterGroups.length > 0 ? '9' : '12')"
		>
			<div
				v-if="
					(listItems || listItems.length > 0) &&
					filterGroups.length > 0
				"
				class="facetted-list__info"
			>
				<span>{{ listItems.length }} </span>
				{{
					" " +
					dataProps.of +
					" " +
					totalItems +
					" " +
					(listItems.length == 1
						? dataProps.subject
						: dataProps.subjects)
				}}
			</div>
			<ul class="grid-equalHeight ul--nostyling facetted-list__items">
				<li
					class="facetted-list__col list__col"
					:class="
						cardType == 'FacettedListItem'
							? 'col-12_md-4'
							: 'col-12_sm-4'
					"
					v-for="item in listItems"
					:key="item.id"
				>
					<component
						:is="cardType"
						:data="item"
						:ariaLabelEmptyField="dataProps.ariaLabelEmptyField"
						:labelDate="dataProps.labelDate"
						:labelLocation="dataProps.labelLocation"
						:labelTime="dataProps.labelTime"
						:at="dataProps.at"
						:textTo="dataProps.to"
						:labelPrice="dataProps.labelPrice"
					>
					</component>
				</li>
			</ul>
			<pagination
				:totalItems="totalItems"
				:pageSize="parseInt(dataProps.pagesize)"
				:currentPage="parseInt(pageIndex)"
				@changePageIndex="changePageIndex"
				:ariaLabelPaginationGotoPage="
					dataProps.arialabelpaginationgotopage
				"
				:ariaLabelPaginationNav="dataProps.arialabelpaginationnav"
				:ariaLabelPaginationNext="dataProps.arialabelpaginationnext"
				:ariaLabelPaginationPrev="dataProps.arialabelpaginationprev"
				:ariaLabelPaginationActivePage="
					dataProps.arialabelpaginationactivepage
				"
			></pagination>
		</div>
	</div>
</template>

<script setup>
import { ref, computed, onMounted, onBeforeUnmount } from "vue";
import axios from "axios";
import Pagination from "../pagination/pagination.vue";
import ListFilters from "./../listFilters/listFilters.vue";
import Spinner from "../../../shared/script/vue/Spinner.vue";
import FacettedListItem from "./facettedListItem.vue";
import NewsListItem from "./../newsList/newsListItem.vue";
import ListItem from "./../newsList/listItem.vue";
import SimpleListCard from "./../newsList/simpleListItem.vue";
import NewslistFilters from "./../newsList/newsListFilters.vue";
import ListHeadline from "../listHeadline.vue";

const apiurl = ref("");
const filterapiurl = ref("/api/filterList/list");
const listItems = ref([]);
const activeFilters = ref({});
const filterGroups = ref([]);
const yearFilters = ref([]);
const filtersUpdate = ref(true);
const pageIndex = ref(0);
const loading = ref(false);
const totalItems = ref(0);
const screenSize = ref("");
const cardType = ref(NewsListItem);
const showDateFilters = ref(false);
const showTextFilter = ref(false);
const startDate = ref("");
const endDate = ref("");
const searchTerm = ref("");
const selectedTags = ref([]);
const fromDateDefault = ref("");
const toDateDefault = ref("");
const defaultTagIds = ref([]);
const buttonText = ref("");
const dataProps = ref({});

const facettedListRef = ref("facettedListRef");

onMounted(() => {
	setDataFromAttributes();
	checkFilterParameters();
	checkPageIndex();
	screenSize.value = utilities.getSize();
	utilities.emitter.on("responsive/sizechange", (size) => {
		screenSize.value = size;
	});
	fetchData(false);
});

onBeforeUnmount(() => {
	utilities.emitter.off("responsive/sizechange");
});

const setDataFromAttributes = () => {
	dataProps.value = facettedListRef.value?.parentElement?.dataset;
	if (dataProps.value) {
		apiurl.value = dataProps.value.apiurl;
		filterapiurl.value = dataProps.value.filterapiurl;
		showDateFilters.value = dataProps.value.showDateFilters == "True";
		showTextFilter.value = dataProps.value.showTextFilter == "True";
		buttonText.value = dataProps.value.btnText;
		if (dataProps.value.cardType) {
			setCard();
		}
	}
};

const isViewportSmall = computed(() => {
	return (
		screenSize.value == "xsmall" ||
		screenSize.value == "small" ||
		screenSize.value == "smallx"
	);
});

const hasHeader = computed(() => {
	return dataProps.value.listHeadline && dataProps.value.listHeadline != "";
});

const tagIds = computed(() => {
	let tagIds = [];
	if (selectedTags.value && selectedTags.value.length > 0) {
		selectedTags.value.forEach((element) => {
			tagIds.push(element.contentId ? element.contentId : element);
		});
	}
	return tagIds;
});

const tagsPostModel = computed(() => {
	var postModel = [];
	filterGroups.value.forEach((item) => {
		if (
			item.values &&
			item.values.some((r) => {
				return tagIds.value.includes(r.contentId);
			})
		) {
			var groupItem = {};
			var tags = [];
			item.values
				?.filter((r) => {
					return tagIds.value.includes(r.contentId);
				})
				?.forEach((element) => {
					tags.push(element.contentId);
				});
			groupItem.DisplayName = item.displayName;
			groupItem.SubTags = tags;

			postModel.push(groupItem);
		}
	});

	return postModel;
});

const years = computed(() => {
	return dataProps.value?.years
		?.substring(1, dataProps.value.years.length - 1)
		.split(",")
		.reverse();
});

const setCard = () => {
	if (dataProps.value.cardType == "FacettedListItem") {
		cardType.value = FacettedListItem;
	} else if (dataProps.value.cardType == "ListItem") {
		cardType.value = ListItem;
	} else if (dataProps.value.cardType == "SimpleListCard") {
		cardType.value = SimpleListCard;
	} else {
		cardType.value = NewsListItem;
	}
};

const fetchData = async (setQueryParameters = true) => {
	loading.value = true;
	try {
		if (filtersUpdate.value) {
			let filterResponse = await axios.post(filterapiurl.value, {
				ContentId: parseInt(dataProps.value.contentid),
			});
			if (filterResponse.status == 200) {
				let filters = JSON.parse(
					JSON.stringify(filterResponse.data.items)
				);

				filterGroups.value = filters;
				filtersUpdate.value = false;
			} else {
				filterGroups.value = [];
			}
		}

		let payload = {
			ContentId: parseInt(dataProps.value.contentid),
			PageIndex: parseInt(pageIndex.value),
			Tags: tagIds.value?.length > 0 ? tagsPostModel.value : [],
		};

		if (endDate.value != "") {
			payload.endDate = endDate.value;
		}
		if (startDate.value != "") {
			payload.startDate = startDate.value;
		}
		if (searchTerm.value != "") {
			payload.searchTerm = searchTerm.value;
		}

		if (yearFilters.value != "" && yearFilters.value.length > 0) {
			payload.Years = yearFilters.value;
		}
		let response = await axios.post(apiurl.value, payload);

		if (response.status == 200) {
			listItems.value = response.data.items;
			totalItems.value = response.data.total;
		} else {
			listItems.value = [];
		}

		loading.value = false;

		if (setQueryParameters) {
			utilities.setQueryStringParameter("pageIndex", pageIndex.value);
		}
		return response;
	} catch (err) {
		loading.value = false;
		return false;
	}
};

const changePageIndex = (index) => {
	let indexPlusOne = index + 1;
	if (
		indexPlusOne >= 1 &&
		indexPlusOne <= Math.ceil(totalItems.value / dataProps.value.pagesize)
	) {
		pageIndex.value = index;
		fetchData();
	}
};

const checkPageIndex = () => {
	const urlParams = new URLSearchParams(window.location.search);
	const pageIndexParam = urlParams.get("pageIndex");
	if (pageIndexParam) {
		pageIndex.value = pageIndexParam;
	}
};

const onFilterUpdate = () => {
	activeFilters.value = {};
	if (tagIds.value && tagIds.value.length > 0) {
		activeFilters.value.tagIds = tagIds.value;
	}
	if (startDate.value) {
		activeFilters.value.startDate = startDate.value;
	}
	if (endDate.value) {
		activeFilters.value.endDate = endDate.value;
	}
	if (searchTerm.value) {
		activeFilters.value.searchTerm = searchTerm.value;
	}
	if (yearFilters.value) {
		activeFilters.value.yearFilters = yearFilters.value;
	}

	if (Object.keys(activeFilters.value).length > 0) {
		utilities.setQueryStringParameter(
			"filters",
			JSON.stringify(activeFilters.value)
		);
	} else {
		utilities.deleteQueryStringParameter("filters");
	}
	if (!isViewportSmall.value) {
		fetchData();
	}
};

const onSubmit = () => {
	fetchData();
};

const checkFilterParameters = () => {
	const urlParams = new URLSearchParams(window.location.search);
	const filters = urlParams.get("filters");

	if (filters) {
		let filterArr = JSON.parse(filters);

		activeFilters.value = filterArr;

		if (activeFilters.value.startDate) {
			startDate.value = activeFilters.value.startDate;
			fromDateDefault.value = startDate.value;
		}
		if (activeFilters.value.endDate) {
			endDate.value = activeFilters.value.endDate;
			toDateDefault.value = endDate.value;
		}
		if (activeFilters.value.searchTerm) {
			searchTerm.value = activeFilters.value.searchTerm;
			searchTermDefault.value = searchTerm.value;
		}
		if (activeFilters.value.tagIds) {
			defaultTagIds.value = activeFilters.value.tagIds;
			selectedTags.value = filterArr.tagIds;
		}
		if (activeFilters.value.yearFilters) {
			yearFilters.value = activeFilters.value.yearFilters;
		}
	}
};

const updateFilters = () => {
	// force filters update when adding dynamic properties to object.
	filters.value = JSON.parse(JSON.stringify(filters.value));
	pageIndex.value = 0;
	utilities.setQueryStringParameter(
		"filters",
		JSON.stringify(activeFilters.value)
	);
	fetchData();
};

const dateFormat = (date) => {
	var parts = date.split(".");
	// Timezone correction: GMT  + 2 hours
	return new Date(parts[2], parseInt(parts[1]) - 1, parts[0], 2, 0, 1);
};

const onUpdateFromDate = (e) => {
	pageIndex.value = 0;
	startDate.value =
		e != "" && dateFormat(e) ? dateFormat(e)?.toISOString() : "";
	onFilterUpdate();
	if (isViewportSmall.value) {
		fetchData();
	}
};

const onUpdateSearchTerm = (e) => {
	pageIndex.value = 0;
	searchTerm.value = e;
	onFilterUpdate();
	if (isViewportSmall.value) {
		fetchData();
	}
};

const onUpdateToDate = (e) => {
	pageIndex.value = 0;
	endDate.value =
		e != "" && dateFormat(e) ? dateFormat(e)?.toISOString() : "";
	onFilterUpdate();
	if (isViewportSmall.value) {
		fetchData();
	}
};

const onUpdateTagFilter = (e) => {
	pageIndex.value = 0;
	selectedTags.value = e;
	onFilterUpdate();
	if (isViewportSmall.value) {
		fetchData();
	}
};

const onYearFilterUpdate = (e) => {
	pageIndex.value = 0;
	yearFilters.value = e;
	onFilterUpdate();
	if (isViewportSmall.value) {
		fetchData();
	}
};
</script>
